var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-listado-desktop"}},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.listadoTiposObras,"items-per-page":20},scopedSlots:_vm._u([{key:"item.acciones",fn:function(ref){
var item = ref.item;
return [_c('opciones',{attrs:{"tipoObra":item}})]}},{key:"item.color",fn:function(ref){
var item = ref.item;
return [_c('v-avatar',{attrs:{"size":"35","color":item.color}})]}},{key:"item.createdAt",fn:function(ref){
var item = ref.item;
return [_c('fecha-humano',{attrs:{"fecha":new Date(item.createdAt)}})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }